<div class="input-wrapper {{ size }}" [ngClass]="{ 'input-disabled': disabled, 'borderless': !border }">

  <input #input class="input" type="text" [disabled]="disabled" [placeholder]="placeholder" [ngModel]="model"
    (ngModelChange)="emitChange($event)">
  <bdr-icon class="input-icon" *ngIf="model && model.length === 0" icon="search"></bdr-icon>
  <bdr-icon class="input-icon input-reset" *ngIf="model && model.length > 0" icon="ico-ko" (click)="reset()"></bdr-icon>
</div>